import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class EstSignOffService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveSignOff(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData) return of({ callSuccess: '0', errorMessage: 'Row data is required.' });
    const clobData = [data.rowData];
    const clobSettings = [{ tax_year: globalService?.globalParams?.tax_year }];
    const params = _.merge({}, {
      process_name: 'EST-save-signoff',
      tax_year: globalService?.globalParams?.tax_year,
      out_year: filterParams?.out_year,
      qtr: filterParams?.qtr,
      workflow: clobData[0]?.WORKFLOW,
      clob_data: JSON.stringify(clobData),
      clob_settings: JSON.stringify(clobSettings)
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=rxomdr`,
      params,
      globalService,
      filterParams
    );
  }
}
